import {
    SET_DYNAMIC_PRICING_LIST,
    SET_DYNAMIC_PRICING_DETAILS,
    SET_DYNAMIC_PRICING_LOADER,
    DELETE_DYNAMIC_PRICING,
    SET_DYNAMIC_PRICING_FILTERS
} from "../actionTypes/dynamicPricingActionTypes";

const initialState: any = {
    dynamicPricingList: {},
    dynamicPricingDetails: {},
    dynamicPricingFilters: null,
    isLoading: false,
};

const dynamicPricingReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_DYNAMIC_PRICING_LOADER:
            return {
                ...state,
                isLoading: action.payload,
            };

        case SET_DYNAMIC_PRICING_FILTERS:
            return {
                ...state,
                dynamicPricingFilters: action.payload,
            };

        case SET_DYNAMIC_PRICING_LIST:
            return {
                ...state,
                dynamicPricingList: action.payload,
            };

        case SET_DYNAMIC_PRICING_DETAILS:
            return {
                ...state,
                dynamicPricingDetails: action.payload,
            };

        case DELETE_DYNAMIC_PRICING:
            // Assuming payload is the MSN (productRef)
            const updatedList = state.dynamicPricingList.data ? 
                state.dynamicPricingList.data.filter((item: any) => item.productRef !== action.payload) : [];
            return {
                ...state,
                dynamicPricingList: {
                    ...state.dynamicPricingList,
                    data: updatedList
                }
            };

        default:
            return state;
    }
};

export default dynamicPricingReducer;
